import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class importacionService {
    
    //----> Queries

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/importacion/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/importacion/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/importacion/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/importacion/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    //----> Commands 

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/importacion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/importacion`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}logistica/importacion/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

}

export default new importacionService();